import { gql } from '@apollo/client';

export const UPSERT_GROUP = gql`
  mutation upsertGroup($input: UpsertGroupInput!) {
    group: upsertGroup(input: $input) {
      id
    }
  }
`;
